import { render, staticRenderFns } from "./RelatoriosVendas.vue?vue&type=template&id=866b60bc&scoped=true&"
import script from "./RelatoriosVendas.vue?vue&type=script&lang=js&"
export * from "./RelatoriosVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866b60bc",
  null
  
)

export default component.exports